import { AdminSchoolStats } from './constants/schoolStats';
import { getSchoolStatsDocRef, getSchoolStatsFromRef } from './utils/school';

export async function getSchoolStats(): Promise<AdminSchoolStats | null> {
  return getSchoolStatsFromRef(getSchoolStatsDocRef());
}
